import React from 'react';
import PropTypes from 'prop-types';
import {
  FDBox,
  FDHeadlineText,
  FDStack,
  FDTitleText,
} from '@facet-wealth/design';
import { useMobileOrMCLayout } from 'Hooks/useMobileLayoutOrMCLayout';
import { BalanceSheetCategoriesAccordion } from './BalanceSheetCategoriesAccordion';

const PADDING_DESKTOP = 4;
const PADDING_MOBILE = 2;

export const BalanceSheetSection = ({
  sectionResource,
  onEditLineItemClick,
  maxWidthOverride,
  expandedCategoryIDs,
  setExpandedCategoryIDs,
  hasBigNumbers,
  isFiltering,
}) => {
  const isMobileOrMC = useMobileOrMCLayout();
  const sectionName = sectionResource.selectedOptionPrompt('sectionName');
  const defaultMaxWidth = '600px';
  const desktopMaxWidth = maxWidthOverride ?? defaultMaxWidth;

  const isEmpty = sectionResource.isTruthy('isEmptyState');
  const hideSectionTitle = isEmpty && isFiltering;
  return (
    <FDBox flex={1} maxWidth={isMobileOrMC ? '100%' : desktopMaxWidth} minWidth={'320px'} width={isMobileOrMC ? '100%' : undefined}>
      <FDBox paddingX={2} paddingY={isMobileOrMC ? PADDING_MOBILE : PADDING_DESKTOP}>
        {!hideSectionTitle && (
        <FDStack direction={'column'} justifyContent={'flex-start'}>
          <FDTitleText value={sectionName} />
          <FDHeadlineText value={sectionResource.attr('total')} />
        </FDStack>
        )}
      </FDBox>
      <BalanceSheetCategoriesAccordion
        expandedCategoryIDs={expandedCategoryIDs}
        setExpandedCategoryIDs={setExpandedCategoryIDs}
        categoriesCollection={sectionResource.attr('categories')}
        onEditLineItemClick={onEditLineItemClick}
        isEmpty={isEmpty}
        emptyTitle={sectionResource.attr('emptyStateTitle')}
        emptyDescription={sectionResource.attr('emptyStateText')}
        hasBigNumbers={hasBigNumbers}
        isFiltering={isFiltering}
        overrideEmptyState
      />
    </FDBox>
  );
};

BalanceSheetSection.defaultProps = {
  maxWidthOverride: null,
};

BalanceSheetSection.propTypes = {
  expandedCategoryIDs: PropTypes.object.isRequired,
  setExpandedCategoryIDs: PropTypes.func.isRequired,
  sectionResource: PropTypes.object.isRequired,
  onEditLineItemClick: PropTypes.func.isRequired,
  maxWidthOverride: PropTypes.string,
  hasBigNumbers: PropTypes.bool.isRequired,
  isFiltering: PropTypes.bool.isRequired,
};
